<template lang='pug'>
  v-content
    v-container(fluid)
      v-flex
        v-card
          v-toolbar(color='white')
            v-toolbar-title(v-model="title") {{ title }}
            v-divider(class="mx-2" inset vertical)
            v-spacer
          v-divider
          //- PermitList(:title='title' :dialogType='dialogType' :ip='ip' :statusSelect='statusSelect' @formSelected='formSelected' @statusSelected='statusSelected')
          v-alert(
            type='error'
            v-if=`(userAuth.hasOwnProperty('isPjs') && userAuth.isPjs)`
          ) 
            div Anda saat ini masuk sebagai Penanggung Jawab Sementara (PJS) pada halaman list approval. Setiap permit yang muncul di sini memerlukan pertimbangan Anda.
            div  Sebelum memilih untuk menolak permit, harap pastikan bahwa Anda telah:
              ul
                li Membaca dan memahami sepenuhnya isi permit.
                li Menilai konsekuensi dari penolakan permit tersebut.
                li Berdiskusi dengan pihak terkait jika terdapat ketidakjelasan atau memerlukan informasi tambahan

          PermitList(:title='title' :dialogType='dialogType' :ip='getIp()')
</template>

<script>
import * as config from "../config/index.json";
import PermitList from "@/components/PermitList.vue";
import { mapGetters, mapState } from "vuex";
import helper from "../helper/index.js";
export default {
  name: "MyApprovalList",
  components: {
    PermitList
  },
  data () {
    return {
      config: config.default,
      title: 'My Approval List',
      dialogType: 'approval',
      ip: {
        headers: [
          {
            text: 'Nomor',
            align: 'start',
            value: 'ipNo',
            width: '160px',
            sortable: false,
          },
          { text: 'Judul Pekerjaan', value: 'ipJudulPekerjaan',width: '210px' },
          { text: 'Tanggal', value: 'ipDateFormat' },
          { text: 'Perusahaan', value: 'ipPerusahaan' },
          { text: 'Form', value: 'ipFormShortName' },
          { text: 'Nama Pemegang Izin', value: 'ipPemegangIzin.name',width: '170px' },
          { 
            text: 'Status', 
            value: 'ipStatusLabel', 
            align: 'center', 
            width: '120px',
            sortable: false,
          },
          { 
            text: 'Source', 
            value: 'source',
            sortable: false, 
          },
          { 
            text: 'Action', 
            value: 'actions',
            sortable: false, 
          },
          { text: '', value: 'data-table-expand' }
        ],
        items: [],
      },
    }
  },
  mounted () {
    this.$store.dispatch("fetchNewMyApprovalv2")
  },
  computed: {
    ...mapState(["myApprovalPermit","newMyApprovalPermit"]),
    ...mapGetters(['userAuth']) // get user data login with combine leave user
  },
  methods: {
    getWITADate:helper.getWITADate,
    formatDate:helper.formatDate,

    getIp() {
      this.ip.items = this.$store.state.newMyApprovalPermitv2.data;
      this.ip.jumlah = this.$store.state.newMyApprovalPermitv2.jumlah;
      var desiredStatus = this.$store.state.newMyApprovalPermitv2.desiredStatus;

      if(this.ip.items){
        for (let i = 0; i < this.ip.items.length; i++) {
          if(this.ip.items[i].ipStatus == 10) {
            const closer = this.ip.items[i].ipPengesahan?.ipWorkflow.find(val => val.status == 9).matrix.some(wf => this.userAuth.group_level?.includes(wf));

            if((desiredStatus.includes(20) || desiredStatus.includes(-1)) && closer){
                this.ip.items[i].ipStatusLabel = "Need Closing";
                this.ip.items[i].ipStatusColor = 9;
            }else{
              this.ip.items[i].ipStatusLabel = this.config.status[this.ip.items[i].ipStatus].name;
              this.ip.items[i].ipStatusColor = this.ip.items[i].ipStatus;
            }

          }else{
            this.ip.items[i].ipStatusLabel = this.config.status[this.ip.items[i].ipStatus].name;
            this.ip.items[i].ipStatusColor = this.ip.items[i].ipStatus;
          }

          if (this.ip.items[i].ipStatus == 2) {
            let workflow = this.ip.items[i].ipWorkflow;
            for (let j = 0; j < workflow.length; j++) {
              if (this.$store.getters.isAuthenticated) {
                for (const item of this.userAuth.group_level) {
                  if (workflow[j].status == 9 && (workflow[j].matrix.includes(item) || workflow[j].matrix.includes("WASKAT"))) {
                    this.ip.items[i].ipStatusLabel = this.config.status[workflow[j].status].name;
                    this.ip.items[i].ipStatusColor = workflow[j].status;
                    break;
                  }
                }
              }
            }

            if (desiredStatus.includes(2) && desiredStatus.length == 1) {
              this.ip.items[i].ipStatusLabel = "On Approval";
              this.ip.items[i].ipStatusColor = 2;
            }
          }

          this.ip.items[i].ipDateFormat = this.formatDate(this.ip.items[i].ipDate);
          this.ip.items[i].ipFormShortName = this.config.ShortenFormName[this.ip.items[i].ipForm];
        }
      }

      return this.ip;
    },
  },
};
</script>
